import { createSlice } from '@reduxjs/toolkit';
import { t } from 'i18next';
import { showSuccessToast } from '../../app/utils/tostify';
import {getImagesList, deleteImageList, getImagesMatch, imagesMatchApprove} from '../apis/imagesAPIs';

interface imageState {
	error: any;
	loading: boolean;
	priceList: Array<any>;
	imagesList: Array<any>;
	selectedImagesList: Array<any>;
	currentPage: number;
	count: number;
	imageMatchCount: number;
	customerDetails: any;
	deviceList: any;
	imageMatchList: any
}

const initialState: imageState = {
	loading: false,
	error: '',
	priceList: [],
	selectedImagesList: [],
	imagesList: [],
	currentPage: 1,
	count: 0,
	imageMatchCount:0,
	customerDetails: {},
	deviceList: [],
	imageMatchList: []
};

const imagesSlice = createSlice({
	name: 'imagesSlice',
	initialState,
	reducers: {
		handlePaginationInImages(state, action: any) {
			state.currentPage = action.payload;
		}
	},
	extraReducers: (builder) => {
		builder.addCase(getImagesList.pending, (state: imageState) => {
			state.loading = true;
			state.error = '';
			state.customerDetails = {};
		});
		builder.addCase(
			getImagesList.fulfilled,
			(state: imageState, action: any) => {
				state.loading = false;
				state.imagesList = action?.payload?.data?.list;
				state.count = action?.payload?.data?.count;
				state.deviceList = [];
				state.error = '';
			}
		);
		builder.addCase(getImagesList.rejected, (state: imageState) => {
			state.loading = false;
		});
		builder.addCase(getImagesMatch.pending, (state: imageState) => {
			state.loading = true;
			state.error = '';
		});
		builder.addCase(
			getImagesMatch.fulfilled,
			(state: imageState, action: any) => {
				state.loading = false;
				state.imageMatchList = action?.payload?.data?.list;
				state.error = '';
				state.imageMatchCount = action?.payload?.data?.count;
			}
		);
		builder.addCase(getImagesMatch.rejected, (state: imageState) => {
			state.loading = false;
		});
		builder.addCase(imagesMatchApprove.pending, (state: imageState) => {
			state.loading = true;
		});
		builder.addCase(imagesMatchApprove.rejected, (state: imageState) => {
			state.loading = false;
		});
		builder.addCase(imagesMatchApprove.fulfilled, (state: imageState) => {
			state.loading = false;
		});
		builder.addCase(deleteImageList.pending, (state: imageState) => {
			state.loading = true;
			state.error = '';
		});
		builder.addCase(
			deleteImageList.fulfilled,
			(state: imageState, action: any) => {
				state.loading = false;
				state.error = '';
				showSuccessToast({ message: t(action?.payload?.message) });
			}
		);
		builder.addCase(deleteImageList.rejected, (state: imageState) => {
			state.loading = false;
		});
	}
});

export const { handlePaginationInImages } = imagesSlice.actions;
export default imagesSlice.reducer;
